import moment from 'moment'

/**
 * 频控类型
 */
export const freOptions = [
  {
    label: 1,
    name: '不限'
  },
  {
    label: 2,
    name: '整日限投'
  },
  {
    label: 3,
    name: '投放周限投'
  },
  {
    label: 6,
    name: '自然周限投'
  },
  {
    label: 4,
    name: '投放月限投'
  },
  {
    label: 7,
    name: '自然月限投'
  },
  {
    label: 5,
    name: '整单限投'
  }
]

/**
 * 判断是否mac设备
 * @returns boolean
 */
export function detectOS() {
  let isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel'
  if (isMac) return true
}

/**
 * 获取每日投放量list
 * @returns boolean
 */
export function getDailyTraffics(traffic = '') {
  return traffic
    // eslint-disable-next-line
    .trim()
    .replace(/[(\s+)|(，)|(;)|(；)|(/\s+/)]/g, ',')
    .split(',')
    .filter(item => item)
}

/**
 * 字符串转数字
 * @param {String} str
 * @returns Number
 */
export function stringToInt(str) {
  if (!/^[0-9]+$/.test(str)) {
    return 0
  }
  return parseInt(str)
}

/**
 * 构建品牌组件所需数据
 * @param {Array} data
 * @returns Array
 */
export function handleBrand(data) {
  let brandModelsData = []
  const brandModelsList = data
  brandModelsList.forEach(element => {
    if (element.parent === 1) {
      brandModelsData.push({
        label: element.tag,
        value: element.tagDeviceId,
        children: []
      })
    }
  })
  for (let i = 0; i < brandModelsData.length; i++) {
    for (let j = 0; j < brandModelsList.length; j++) {
      if (brandModelsList[j].parent === brandModelsData[i].value) {
        brandModelsData[i].children.push({
          value: brandModelsList[j].tagDeviceId,
          label: brandModelsList[j].tag
        })
      }
    }
  }
  return brandModelsData
}

/**
 * 构建地域组件所需数据
 * @param {Array} data
 * @returns Array
 */
export function buildRegionData(data) {
  let regionReturnData = []
  const areaData = data.slice().filter(item => {
    return item.name !== '未匹配'
  })
  areaData.forEach(item => {
    if (item.parent === 0) {
      regionReturnData.push({
        value: item.regionId,
        label: item.name,
        children: []
      })
    }
  })
  for (let i = 0; i < regionReturnData.length; i++) {
    for (let j = 0; j < areaData.length; j++) {
      if (areaData[j].parent === regionReturnData[i].value) {
        regionReturnData[i].children.push({
          value: areaData[j].regionId,
          label: areaData[j].name
        })
      }
    }
  }
  return regionReturnData
}

/**
 * 构建尺寸定向选项数据
 * @param {Array} data
 * @returns Array
 */
export function handleDeviceSize(data) {
  let options = data.map(item => {
    return {
      label: item.dictLabel,
      value: item.dictValue,
      dictSort: item.dictSort
    }
  })
  const deleteValue = options.shift()
  options.unshift({
    value: '-1',
    label: '不限',
    dictSort: 100
  })
  options.push(deleteValue)
  return options
}

/**
 * 表单提交数据处理，投放排期
 * @param {Array} data
 * @returns Array
 */
export function handleFormRegionDaily(data, key) {
  const arr = data.map(item => {
    return {
      daily: item.daily,
      totalTraffic: item[key] !== '-' ? parseInt(item[key]) : 0
    }
  })
  return arr
}

/**
 * 表单提交数据处理，媒体标签
 * @param {Array} data
 * @returns Array
 */
export function handleFormMediaTags(data) {
  const videoList = []
  data.forEach(item => {
    if (item.classType && item.pkgId) {
      // 选择的是三级
      videoList.push({
        classType: item.classType,
        classTypeName: item.classTypeName,
        pkgId: item.pkgId,
        pkgName: item.pkgName,
        classId: item.value,
        className: item.label
      })
    } else if (item.classType && !item.pkgId) {
      // 选择的是二级
      videoList.push({
        classType: item.classType,
        classTypeName: item.classTypeName,
        pkgId: item.value,
        pkgName: item.label
      })
    } else {
      // 选择的是一级
      videoList.push({
        classType: item.value,
        classTypeName: item.label
      })
    }
  })
  return videoList
}

/**
 * 表单提交数据处理，投放时间
 * @param {Array} data
 * @returns Array
 */
export function handleFormTimeList(data) {
  let arr = []
  data
    .filter(({ timeDay }) => timeDay && timeDay !== [])
    .forEach(item => {
      const begin = item.timeHours.length ? item.timeHours[0] : '00:00:00'
      const end = item.timeHours.length ? item.timeHours[1] : '23:59:59'
      arr.push({
        beginTime: item.timeDay[0] + ' ' + begin,
        endTime: item.timeDay[1] + ' ' + end
      })
    })
  return arr
}

/**
 * 表单回显处理， 每日排期量/每日赠送
 * @param {Array} trafficList
 */
export function getReviewDailyTraffic(trafficList = []) {
  trafficList.sort((prev, cur) => {
    return prev.daily - cur.daily
  })
  return trafficList.map(item => item.totalTraffic).join(',')
}

/**
 * 表单回显处理， 场景标签
 * @param {Array} allList
 * @param {Array} currData
 * @returns Array
 */
export function handleReviewMedia(allList, currData) {
  const arr = []
  currData.forEach(item => {
    if (item.classId) {
      // 选择的是三级标签
      arr.push({
        value: item.classId,
        label: item.className,
        pkgId: item.pkgId,
        pkgName: item.pkgName,
        classType: item.classType,
        classTypeName: item.classTypeName
      })
    } else if (item.pkgId) {
      // 选择的是二级标签
      const children = allList.filter(list => list.val === item.classType)[0].children
      arr.push({
        value: item.pkgId,
        label: item.pkgName,
        children: children.filter(child => child.value === item.pkgId),
        classType: item.classType,
        classTypeName: item.classTypeName
      })
    } else {
      const children = allList.filter(list => list.value === item.classType)
      if (children.length > 0) {
        arr.push({
          value: item.classType,
          label: item.classTypeName,
          children: children[0].children
        })
      }
    }
  })
  return arr
}

/**
 * 表单回显处理， 地域定向
 * @param {Array} allList
 * @param {Array} currData
 * @returns Array
 */
export function handleReviewRegion(allList, currData) {
  let arr = []
  currData.forEach(item => {
    const index = allList.findIndex(({ value }) => value === item.region)
    if (index > -1) {
      // 选择省份
      arr.push({
        value: item.region,
        label: allList[index].label,
        children: allList[index].children
      })
    } else {
      // 特殊处理批量建单过来的地区数据
      const parentRegion = parseInt(item.region.toString().substring(0, 2))
      const allChildren = allList.filter(({ value }) => value === parentRegion)
      const parentIndex = allList.findIndex(({ value }) => value === parentRegion)
      const childrenIndex = allList[parentIndex].children.findIndex(({ value }) => value === item.region)
      // 只有一个children的情况，批量建单传过来是市的值，就是选择了省
      if (allChildren.length > 0 && allChildren[0].children.length === 1 && childrenIndex === 0) {
        arr.push({
          value: parseInt(parentRegion),
          label: allList[parentIndex].label,
          children: allList[parentIndex].children
        })
      } else {
        arr.push({
          value: item.region,
          label: allList[parentIndex].children[childrenIndex].label
        })
      }
    }
  })
  return arr
}

/**
 * 表单回显处理， 品牌、mac标签、lbs标签
 * @param {Array} allList
 * @param {Array} currData
 * @returns Array
 */
export function handleReviewPannelData(allList, currData) {
  const arr = []
  currData.forEach(item => {
    allList.forEach(element => {
      if (item === element.value) {
        arr.push(element)
      } else {
        if (element.children && element.children.length > 0) {
          element.children.forEach(child => {
            if (child.value === item) {
              arr.push(child)
            }
          })
        }
      }
    })
  })
  return arr
}

/**
 * 表单回显处理， 人群策略标签
 * @param {Array} allList
 * @param {Array} currData
 * @returns Array
 */
export function handleReviewDmp(allList, currData) {
  return allList.filter(item => {
    return currData.some(val => val.crowdId === item.value)
  })
}

export function getBetweenDate(start, end) {
  let result = []
  let startTime = moment(start).format('YYYY-MM-DD')
  const endTime = moment(end).format('YYYY-MM-DD')
  while (moment(startTime).isSameOrBefore(endTime)) {
    result.push(startTime)
    startTime = moment(startTime).add(1, 'days').format('YYYY-MM-DD')
  }
  return result
}

/**
 * 校验时间是否有重复
 * @returns boolean
 */
export function checkPutTime(timeList = []) {
  const allTimeList = timeList.filter(item => item.timeDay && item.timeDay.length)
  let timeDay = allTimeList.map(item => {
    return getBetweenDate(item.timeDay[0], item.timeDay[1])
  })
  const allTime = []
  allTimeList.forEach((item, index) => {
    const beginHour = item.timeHours.length ? item.timeHours[0] : '00:00:00'
    const endHour = item.timeHours.length ? item.timeHours[1] : '23:59:59'
    timeDay[index].forEach(h => {
      allTime.push({
        beginTime: moment(h).format('YYYY-MM-DD ' + beginHour),
        endTime: moment(h).format('YYYY-MM-DD ' + endHour)
      })
    })
  })
  const startTimeArr = []
  const endTimeArr = []
  allTime.forEach(item => {
    startTimeArr.push(new Date(item.beginTime).getTime())
    endTimeArr.push(new Date(item.endTime).getTime())
  })
  const begin = startTimeArr.sort()
  const end = endTimeArr.sort()
  for (let i = 0; i < begin.length; i++) {
    if (end[i - 1] && begin[i] <= end[i - 1]) {
      return true
    }
  }
}

/**
 * 将连续时间放在一起
 * @param data
 * @returns {*}
 */
function sortDateList(data) {
  data.sort(function (a, b) {
    return new Date(a).getTime() - new Date(b).getTime()
  })
  return data
}
export function dateSplitList(arr) {
  // 转时间戳
  function transTime(date) {
    return new Date(date).getTime()
  }
  let result = []
  let i = 0
  const list = sortDateList(arr)
  if (list.length === 0) return []
  list.forEach((item, index) => {
    if (index === 0) {
      result[0] = [item]
    } else if (
      transTime(item) - transTime(list[index - 1]) ===
      86400000
    ) {
      // 判断当前值 和 前一个值是否相差 1
      result[i].push(item)
    } else {
      result[++i] = [item]
    }
  })
  return result
}

/**
 * 判断是不是周末
 * @returns boolean
 */
export function checkWeekend(day) {
  let date = new Date(day)
  return date.getDay() === 6 || date.getDay() === 0
}
